import { all, put, takeEvery, call, select } from "redux-saga/effects";
import { REGISTRATIONS_ACTIONS, REGISTRATIONS_TYPES } from "./actions";
import {
  getRegistration as APIgetRegistration,
  getRegistrations as APIgetRegistrations,
  createRegistration as APIcreateRegistration,
  updateRegistration as APIupdateRegistration,
  deleteRegistration as APIdeleteRegistration,
  syncRegistrationProfiles as APIsyncRegistrationProfiles,
  syncRegistrationParkings as APIsyncRegistrationParkings,
  syncRegistrationMaterialCategories as APIsyncRegistrationMaterialCategories,
  syncRegistrationDepartments as APIsyncRegistrationDepartments,
  syncRegistrationCrewMaterialTemplates as APIsyncRegistrationCrewMaterialTemplates,
  updateRegistrationAllowedCateringOption as APIupdateRegistrationAllowedCateringOption
} from "../../services/api/registrations";
import { navigateTo } from "../navigation/saga";
import { registrationsFilters } from "./selectors";

export function* watchRegistrationsActions() {
  yield all([
    takeEvery(REGISTRATIONS_TYPES.LOAD_ALL_REQUEST, getRegistrations)
  ]);
  yield all([takeEvery(REGISTRATIONS_TYPES.LOAD_REQUEST, getRegistration)]);
  yield all([
    takeEvery(REGISTRATIONS_TYPES.CREATE_REQUEST, createRegistration)
  ]);
  yield all([
    takeEvery(REGISTRATIONS_TYPES.UPDATE_REQUEST, updateRegistration)
  ]);
  yield all([
    takeEvery(REGISTRATIONS_TYPES.DELETE_REQUEST, deleteRegistration)
  ]);
  yield all([takeEvery(REGISTRATIONS_TYPES.CREATE_SUCCESS, getRegistrations)]);
  yield all([takeEvery(REGISTRATIONS_TYPES.DELETE_SUCCESS, getRegistrations)]);
  yield all([takeEvery(REGISTRATIONS_TYPES.UPDATE_FILTERS, getRegistrations)]);
}

function* getRegistrations(action) {
  try {
    const filters = yield select(registrationsFilters);
    const registrations = yield call(APIgetRegistrations, filters);
    yield put(REGISTRATIONS_ACTIONS.loadAllSuccess(registrations));
  } catch (e) {
    yield put(REGISTRATIONS_ACTIONS.loadAllFailure(e));
  }
}

function* getRegistration(action) {
  const { id } = action.payload;
  try {
    const registration = yield call(APIgetRegistration, id);
    yield put(REGISTRATIONS_ACTIONS.loadSuccess(registration));
  } catch (e) {
    yield put(REGISTRATIONS_ACTIONS.loadFailure(e));
  }
}

function* createRegistration(action) {
  const { values } = action.payload;
  try {
    const registration = yield call(APIcreateRegistration, values);

    yield call(APIsyncRegistrationProfiles, registration.id, {
      profileIds: values.profiles
    });
    yield call(APIsyncRegistrationParkings, registration.id, {
      parkingIds: values.parkings
    });
    yield call(APIsyncRegistrationMaterialCategories, registration.id, {
      materialCategoryIds: values.materialCategoryIds
    });
    yield call(APIsyncRegistrationDepartments, registration.id, {
      departmentIds: values.departments
    });
    yield call(APIsyncRegistrationCrewMaterialTemplates, registration.id, {
      crewMemberMaterialTemplateIds: values.crewMemberMaterialTemplateIds
    });
    yield call(APIupdateRegistrationAllowedCateringOption, registration.id, {
      cateringOptionIds: values.allowedCateringOptions
    });

    if (values.redirect) {
      yield call(
        navigateTo,
        "/admin/registrations/" + registration.id + "/edit"
      );
    } else {
      yield call(navigateTo, "/admin/registrations");
    }

    yield put(REGISTRATIONS_ACTIONS.createSuccess(registration));
  } catch (e) {
    yield put(REGISTRATIONS_ACTIONS.createFailure(e));
  }
}

function* updateRegistration(action) {
  const { id, values } = action.payload;
  try {
    const registration = yield call(APIupdateRegistration, id, values);

    yield call(APIsyncRegistrationProfiles, id, {
      profileIds: values.profiles
    });
    yield call(APIsyncRegistrationParkings, id, {
      parkingIds: values.parkings
    });
    yield call(APIsyncRegistrationMaterialCategories, registration.id, {
      materialCategoryIds: values.materialCategoryIds
    });
    yield call(APIsyncRegistrationDepartments, id, {
      departmentIds: values.departments
    });
    yield call(APIsyncRegistrationCrewMaterialTemplates, id, {
      crewMemberMaterialTemplateIds: values.crewMemberMaterialTemplateIds
    });
    yield call(APIupdateRegistrationAllowedCateringOption, registration.id, {
      cateringOptionIds: values.allowedCateringOptions
    });

    yield put(REGISTRATIONS_ACTIONS.updateSuccess(registration));

    if (values.redirect) {
      yield call(navigateTo, values.redirect);
    } else {
      yield call(navigateTo, "/admin/registrations");
    }
  } catch (e) {
    yield put(REGISTRATIONS_ACTIONS.updateFailure(e));
  }
}

function* deleteRegistration(action) {
  const { id } = action.payload;
  try {
    const registration = yield call(APIdeleteRegistration, id);
    yield put(REGISTRATIONS_ACTIONS.deleteSuccess(registration));
  } catch (e) {
    yield put(REGISTRATIONS_ACTIONS.deleteFailure(e));
  }
}
